import { CompareSvg } from "@/assets/icons";
import styles from "./index.module.scss";
import { TouchEventHandler, useEffect } from "react";
import clsx from "clsx";

type CompareButtonProps = {
  style?: object;
  className?: string;
  children?: any;
  onCompare?: () => void;
  onCancelCompare?: () => void;
}

const CompareButton = (props: CompareButtonProps) => {
  const {
    style = {},
    className,
    children,
    onCompare,
    onCancelCompare,
  } = props;
  
  const handleTouchStart: TouchEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    onCompare?.();
  }

  useEffect(() => {
    if (onCancelCompare) {
      document.addEventListener("mouseup", onCancelCompare);
      document.addEventListener("touchend", onCancelCompare);

      return () => {
        document.removeEventListener("mouseup", onCancelCompare);
        document.removeEventListener("touchend", onCancelCompare);
      }
    }
  }, []);

  return (
    <button
      style={style}
      className={clsx(
        styles["compare_button"],
        className
      )}
      onMouseDown={onCompare}
      onTouchStart={handleTouchStart}
      onContextMenu={e => e.preventDefault()}
    >
      <CompareSvg></CompareSvg>

      {children}
    </button>
  )
}

export default CompareButton;